var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightPagination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99662 10.0157C9.99727 10.3489 9.88108 10.6718 9.66822 10.9284L2.52905 19.4848C2.2867 19.7761 1.93843 19.9592 1.56087 19.994C1.18332 20.0287 0.807395 19.9123 0.515808 19.6702C0.22422 19.4282 0.0408521 19.0803 0.0060419 18.7032C-0.0287683 18.3261 0.0878306 17.9507 0.330189 17.6595L6.72688 10.0157L0.558644 2.37192C0.440039 2.22605 0.351468 2.05821 0.298022 1.87804C0.244576 1.69787 0.227308 1.50893 0.24721 1.32207C0.267113 1.13521 0.323794 0.954128 0.413995 0.789221C0.504197 0.624315 0.626141 0.478838 0.772818 0.361155C0.91963 0.230555 1.09186 0.131643 1.27873 0.0706177C1.4656 0.00959206 1.66307 -0.0122299 1.85877 0.00651169C2.05447 0.0252552 2.24419 0.0841618 2.41604 0.179541C2.58789 0.274921 2.73817 0.404722 2.85745 0.560806L9.75389 9.11726C9.93311 9.3812 10.0186 9.69753 9.99662 10.0157Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightPagination);
export default __webpack_public_path__ + "static/media/arrow-right-pagination.1fa22e802cfa951a2519252a364649b6.svg";
export { ForwardRef as ReactComponent };